/* Dudes Gourmet v2: cart drawer, bottle-deal tiers, filters, gallery. No dependencies. */
(function () {
  'use strict';
  var DG = window.DG || {};
  var tiers = (DG.tiers || []).filter(function (t) { return t.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  var top = tiers[tiers.length - 1] || { qty: 6, pct: 20 };
  var cart = null;
  var toastTimer = null;

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L20 7"/></svg>';
  // Animate forward; when a goal is reached and the next one starts, snap back to empty first so the reset reads clearly.
  function setBar(el, pct) {
    if (!el) return;
    var prev = parseFloat(el.style.width) || 0;
    if (pct < prev - 1) { el.style.transition = 'none'; el.style.width = '0%'; void el.offsetWidth; el.style.transition = ''; }
    el.style.width = pct + '%';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function word(n) { return n === 1 ? DG.unit : DG.units; }
  function isStack(item) {
    // Subscription bottles count toward the bottle deals too; the subscription's own % comes on top.
    if (DG.stackIds && DG.stackIds.length) return DG.stackIds.indexOf(item.product_id) !== -1;
    return item.original_price === DG.stackPrice;
  }

  function summarize(c) {
    var count = 0;
    (c && c.items || []).forEach(function (i) { if (isStack(i)) count += i.quantity; });
    var tier = null;
    tiers.forEach(function (t) { if (count >= t.qty) tier = t; });
    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (count < tiers[i].qty) { next = tiers[i]; break; } }
    var total = c ? c.total_price : 0;
    var applied = c ? c.total_discount : 0;
    // Before the tier discount shows up in the cart, estimate the total so the shipping message is honest.
    var est = total;
    if (tier && !applied) {
      var stackSub = 0;
      c.items.forEach(function (i) { if (isStack(i)) stackSub += i.final_line_price; });
      est = total - Math.round(stackSub * tier.pct / 100);
    }
    var msg;
    if (count === 0) msg = 'Any ' + tiers.map(function (t) { return t.qty + ' = ' + t.pct + '% off'; }).join('. Any ') + '.';
    else if (next && !tier) msg = (next.qty - count) + ' more ' + word(next.qty - count) + ' unlocks ' + next.pct + '% off';
    else if (next) msg = tier.pct + '% off unlocked. ' + (next.qty - count) + ' more for ' + next.pct + '% off';
    else if (est < DG.freeShip) msg = tier.pct + '% off unlocked. ' + money(DG.freeShip - est) + ' more for free shipping';
    else msg = tier.pct + '% off + free shipping unlocked';
    // The bar tracks one goal at a time: it fills to the next tier, shows full the moment a tier unlocks,
    // then resets toward the next one. After the top tier it tracks free shipping.
    var goal = null, from = 0;
    for (var g = 0; g < tiers.length; g++) { if (count <= tiers[g].qty) { goal = tiers[g]; from = g ? tiers[g - 1].qty : 0; break; } }
    var bar, fromLabel, toLabel;
    if (goal) {
      bar = (count - from) / (goal.qty - from) * 100;
      fromLabel = from ? from + ' ' + DG.units : '0';
      toLabel = goal.qty + ' ' + DG.units + ' · ' + goal.pct + '% off';
    } else {
      // Free-shipping leg starts where the top tier leaves off, so the bar resets instead of opening nearly full.
      var base = top.qty * DG.stackPrice * (1 - top.pct / 100);
      bar = DG.freeShip > base ? (est - base) / (DG.freeShip - base) * 100 : 100;
      fromLabel = top.pct + '% off unlocked';
      toLabel = money(DG.freeShip).replace('.00', '') + ' · free shipping';
    }
    return {
      count: count, tier: tier, next: next, msg: msg, total: total, est: est, applied: applied,
      pay: applied ? total : est, items: c ? c.item_count : 0,
      bar: Math.max(0, Math.min(bar, 100)), fromLabel: fromLabel, toLabel: toLabel,
      shipFree: est >= DG.freeShip
    };
  }

  function fetchCart() {
    return fetch(DG.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(url, body) {
    var isForm = body instanceof FormData;
    return fetch(url + '.js', {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not update cart'); return j; });
    });
  }

  /* ---------- render ---------- */
  function renderTrackers(s) {
    $$('[data-tracker]').forEach(function (el) {
      var t = $('[data-tracker-title]', el); if (t) t.textContent = s.count + ' ' + word(s.count) + (s.items ? ' · ' + money(s.pay) : ' in your cart');
      var p = $('[data-tracker-pct]', el); if (p) p.textContent = s.tier ? s.tier.pct + '% off' : 'No discount yet';
      setBar($('.bar__fill', el), s.bar);
      var a = $('[data-goal-from]', el); if (a) a.textContent = s.fromLabel;
      var b = $('[data-goal-to]', el); if (b) b.textContent = s.toLabel;
      var m = $('[data-tracker-msg]', el); if (m) m.textContent = s.msg;
    });
  }
  function renderCounts(c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    var qty = {};
    c.items.forEach(function (i) { qty[i.product_id] = (qty[i.product_id] || 0) + i.quantity; });
    $$('[data-card]').forEach(function (card) {
      var n = qty[card.getAttribute('data-pid')] || 0;
      var lab = $('[data-in-cart]', card); if (lab) lab.textContent = n ? n + ' in cart' : '';
      var btn = $('[data-add]', card);
      if (btn) { btn.textContent = n ? 'Add another' : 'Add'; btn.classList.toggle('btn--dark', !!n); }
    });
  }
  function renderDrawer(c, s) {
    var d = $('#CartDrawer'); if (!d) return;
    $('[data-drawer-msg]', d).textContent = s.msg;
    setBar($('[data-drawer-bar]', d), s.bar);
    $('[data-drawer-from]', d).textContent = s.fromLabel;
    $('[data-drawer-to]', d).textContent = s.toLabel;
    var ms = tiers.map(function (t) { return { b: t.qty + ' ' + DG.units, s: t.pct + '% off', on: s.count >= t.qty }; });
    ms.push({ b: money(DG.freeShip).replace('.00', ''), s: 'Free shipping', on: s.shipFree });
    $('[data-milestones]', d).innerHTML = ms.map(function (m) {
      return '<div class="milestone' + (m.on ? ' is-done' : '') + '"' + (m.on ? ' aria-label="' + esc(m.s) + ' unlocked"' : '') + '><b>' + esc(m.b) + '</b><span>' + (m.on ? CHECK + ' ' : '') + esc(m.s) + '</span></div>';
    }).join('');
    var body = $('[data-drawer-body]', d);
    if (!c.items.length) {
      body.innerHTML = '<div class="drawer__empty"><p>Your cart is empty.</p><a class="btn" href="' + esc(DG.routes.root) + 'collections/all">Shop seasonings</a></div>';
    } else {
      var html = c.items.map(function (i) {
        var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        var price = i.original_line_price !== i.final_line_price
          ? '<s>' + money(i.original_line_price) + '</s> ' + money(i.final_line_price) : money(i.final_line_price);
        var plan = i.selling_plan_allocation ? '<div class="line__sub">' + esc(i.selling_plan_allocation.selling_plan.name) + ' · <button type="button" class="link" data-unsubscribe="' + esc(i.key) + '">make it one-time</button></div>' : '';
        return '<div class="line">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
          '<div class="line__info"><a class="line__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' +
          '<div class="line__price">' + price + '</div>' + plan + '</div>' +
          '<div class="qty"><button type="button" data-change="' + esc(i.key) + '" data-qty="' + (i.quantity - 1) + '" aria-label="Remove one ' + esc(i.product_title) + '">−</button>' +
          '<span>' + i.quantity + '</span>' +
          '<button type="button" data-change="' + esc(i.key) + '" data-qty="' + (i.quantity + 1) + '" aria-label="Add one ' + esc(i.product_title) + '">+</button></div></div>';
      }).join('');
      html += subOffer(c, s);
      var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = 1; });
      var sug = (DG.suggest || []).filter(function (p) { return !inCart[p.pid]; }).slice(0, 2);
      if (sug.length) {
        var title = !s.tier ? 'Add one to get closer to ' + tiers[0].pct + '% off' : s.next ? 'Keep going to ' + s.next.pct + '% off' : 'Round it out';
        html += '<p class="suggest__title">' + esc(title) + '</p><div class="suggest">' + sug.map(function (p) {
          return '<div class="suggest__item">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') +
            '<p>' + esc(p.title) + '</p><button type="button" data-add data-variant-id="' + p.id + '" data-title="' + esc(p.title) + '" data-quiet>+ Add</button></div>';
        }).join('') + '</div>';
      }
      body.innerHTML = html;
    }
    $('[data-sum-count]', d).textContent = s.count ? '(' + c.item_count + ' items)' : '';
    $('[data-sum-sub]', d).textContent = money(c.original_total_price || c.items_subtotal_price);
    var save = $('[data-sum-save]', d);
    if (c.total_discount > 0) {
      save.hidden = false;
      var names = [];
      (c.cart_level_discount_applications || []).forEach(function (a) { if (names.indexOf(a.title) === -1) names.push(a.title); });
      c.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (x) { var n = x.discount_application.title; if (names.indexOf(n) === -1) names.push(n); }); });
      $('[data-sum-save-label]', d).textContent = names.join(' + ') || 'You save';
      $('[data-sum-save-amt]', d).textContent = '−' + money(c.total_discount);
    } else if (s.tier) {
      save.hidden = false;
      $('[data-sum-save-label]', d).textContent = 'Bottle deal (' + s.tier.pct + '% off)';
      $('[data-sum-save-amt]', d).textContent = '−' + money(s.total - s.est);
    } else save.hidden = true;
    $('[data-sum-ship]', d).textContent = s.shipFree ? 'Free' : 'Free at ' + money(DG.freeShip).replace('.00', '');
    $('[data-checkout]', d).textContent = c.items.length ? 'Checkout · ' + money(s.applied ? c.total_price : s.est) : 'Checkout';
    $('[data-checkout]', d).disabled = !c.items.length;
  }
  /* ---------- subscribe & save offer (cart only) ----------
     Shopify Subscriptions plan only. The subscription % stacks on top of the bottle deal (subscription
     bottles count toward 3 and 6), so subscribing is always the better price and the offer always shows. */
  function planFor(i) { return DG.plans && DG.plans[i.product_id]; }
  var justSubbed = false;
  function subDone(c) {
    var subs = c.items.filter(function (i) { return i.selling_plan_allocation; });
    if (!subs.length) return '';
    var n = 0; subs.forEach(function (i) { n += i.quantity; });
    var pl = subs[0].selling_plan_allocation.selling_plan;
    var m = /(\d+(?:\.\d+)?)%/.exec(pl.name || ''); var pct = m ? m[1] : '';
    var html = '<div class="sub-done' + (justSubbed ? ' is-new' : '') + '" role="status">' +
      '<b>' + CHECK.replace('width="12" height="12"', 'width="18" height="18"') + ' You\'re subscribed</b>' +
      '<p>' + n + ' ' + esc(word(n)) + ' every month' + (pct ? ', with an extra ' + esc(pct) + '% off every delivery' : '') + '. Pause or cancel anytime.</p></div>';
    justSubbed = false;
    return html;
  }
  function subOffer(c, s) {
    var lines = c.items.filter(function (i) { return !i.selling_plan_allocation && planFor(i); });
    if (!lines.length) return subDone(c);
    var pct = planFor(lines[0]).pct;
    var what = lines.length === 1 ? esc(lines[0].product_title.replace(/ Seasoning$/, '')) : 'these';
    var label = s.tier ? 'Subscribe &amp; save an extra ' + pct + '%' : 'Subscribe &amp; save ' + pct + '%';
    var note = s.tier ? 'On top of your ' + s.tier.pct + '% bottle deal. Pause anytime and resume when you\'re ready.' : 'Pause anytime and resume when you\'re ready.';
    return '<div class="sub-offer"><b>Get ' + what + ' every month</b>' +
      '<p>' + esc(note) + '</p>' +
      '<button type="button" class="btn btn--dark" data-subscribe>' + label + '</button></div>';
  }
  function setPlans(on, keys, btn) {
    var c = cart; if (!c) return Promise.resolve();
    var todo = c.items.filter(function (i) { return keys ? keys.indexOf(i.key) !== -1 : (!i.selling_plan_allocation && planFor(i)); });
    var done = 0;
    function progress() {
      if (!btn) return;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = (on ? 'Subscribing' : 'Updating') + (todo.length > 1 ? ' ' + Math.min(done + 1, todo.length) + ' of ' + todo.length : '') + '…';
    }
    progress();
    // Change lines one at a time; each change returns a new cart and can re-key lines.
    return todo.reduce(function (p, i) {
      return p.then(function () {
        return post(DG.routes.change, { id: i.key, quantity: i.quantity, selling_plan: on ? planFor(i).id : null }).then(function () { done++; progress(); });
      });
    }, Promise.resolve()).then(fetchCart).then(function (n) { if (on) justSubbed = true; return renderAll(n); });
  }

  function renderAll(c) {
    cart = c;
    var s = summarize(c);
    renderCounts(c); renderTrackers(s); renderDrawer(c, s);
    bestDeal(c, s);
    return s;
  }

  /* ---------- best deal wins ----------
     A code like KICKOFF10 doesn't combine with the bottle deals, and Shopify lets an entered code
     beat an automatic discount. So when the bottle deal saves more, park the code and let the deal
     apply. If the shopper drops back down a tier, bring the code back. */
  var PARK = 'dgParkedCodes', dealBusy = false;
  function ss(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function setCodes(codes) { return post(DG.routes.root + 'cart/update', { discount: codes.join(',') }).then(fetchCart); }
  function bestDeal(c, s) {
    if (dealBusy || !c) return;
    var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
    var parked = ss(PARK);
    var tierOn = c.items.some(function (i) { return (i.line_level_discount_allocations || []).length; });
    var act = null;
    if (s.tier && codes.length && !tierOn) {
      var sub = 0; c.items.forEach(function (i) { if (isStack(i)) sub += i.original_line_price; });
      var dealSave = Math.round(sub * s.tier.pct / 100);
      var who = (window.__st && window.__st.cid) || 0;
      var tried = parked && parked.failed === s.tier.qty + ':' + who;
      if (dealSave > c.total_discount && !tried) act = function () {
        var before = c.total_discount;
        return setCodes([]).then(function (n) {
          if (n.total_discount > before) { ss(PARK, { codes: codes, qty: s.tier.qty }); return n; }
          // Deal didn't apply (not eligible yet): put the code back and don't try again at this tier.
          return setCodes(codes).then(function (m) { ss(PARK, { codes: [], failed: s.tier.qty + ':' + who }); return m; });
        });
      };
    } else if (parked && parked.codes && parked.codes.length && (!s.tier || s.tier.qty < parked.qty)) {
      act = function () { ss(PARK, null); return setCodes(parked.codes.concat(codes)); };
    }
    if (!act) return;
    dealBusy = true;
    act().then(function (n) { dealBusy = false; renderAll(n); }, function () { dealBusy = false; });
  }

  /* ---------- drawer + toast ---------- */
  var lastFocus = null, lockedY = null;
  // iPad/iPhone Safari ignores overflow:hidden for touch scrolling, so pin the page in place while the cart is open.
  function lockScroll() {
    if (lockedY !== null) return;
    lockedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    document.documentElement.style.overflow = 'hidden';
    b.position = 'fixed'; b.top = -lockedY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
  }
  function unlockScroll() {
    if (lockedY === null) return;
    var b = document.body.style;
    document.documentElement.style.overflow = '';
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    window.scrollTo(0, lockedY); lockedY = null;
  }
  function openDrawer() {
    var d = $('#CartDrawer'); if (!d) return;
    hideToast();
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    lockScroll();
    var close = $('[data-close-cart]', d); if (close) close.focus();
    if (!cart) fetchCart().then(renderAll);
  }
  function closeDrawer() {
    var d = $('#CartDrawer'); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function showToast(title, s) {
    var t = $('#CartToast'); if (!t) return;
    $('[data-toast-title]', t).textContent = title + ' added';
    $('[data-toast-msg]', t).textContent = s.msg;
    setBar($('.bar__fill', t), s.bar);
    $('[data-toast-count]', t).textContent = cart ? cart.item_count : '';
    var tot = $('[data-toast-total]', t); if (tot) tot.textContent = 'Cart total ' + money(s.pay);
    t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }
  function hideToast() {
    var t = $('#CartToast'); if (!t) return;
    t.classList.remove('is-on');
    clearTimeout(toastTimer);
  }

  function addItems(body, title, quiet, btn) {
    if (btn) { btn.disabled = true; }
    return post(DG.routes.add, body).then(fetchCart).then(function (c) {
      var s = renderAll(c);
      if (quiet || $('#CartDrawer.is-open')) return;
      showToast(title || 'Item', s);
    }).catch(function (e) {
      alertInline(btn, e.message);
    }).then(function () { if (btn) btn.disabled = false; });
  }
  function alertInline(btn, text) {
    var box = btn && btn.closest('[data-card], form, .suggest__item');
    var el = box && $('[data-error]', box);
    if (el) { el.textContent = text; el.hidden = false; }
  }

  /* ---------- events ---------- */
  // Capture phase so old app scripts (Rebuy) can't swallow cart clicks before this theme sees them.
  window.addEventListener('click', function (e) {
    var t = e.target.closest('[data-add],[data-open-cart],[data-close-cart],[data-change],[data-subscribe],[data-unsubscribe],[data-toast-close],[data-filter],[data-thumb],[data-menu-toggle],[data-qty-step]');
    if (!t) return;
    if (t.hasAttribute('data-add')) {
      e.preventDefault();
      addItems({ items: [{ id: Number(t.getAttribute('data-variant-id')), quantity: 1 }] }, t.getAttribute('data-title'), t.hasAttribute('data-quiet'), t);
    } else if (t.hasAttribute('data-open-cart')) {
      e.preventDefault(); e.stopImmediatePropagation(); openDrawer();
    } else if (t.hasAttribute('data-close-cart')) {
      e.preventDefault(); closeDrawer();
    } else if (t.hasAttribute('data-toast-close')) {
      hideToast();
    } else if (t.hasAttribute('data-change')) {
      t.disabled = true;
      post(DG.routes.change, { id: t.getAttribute('data-change'), quantity: Number(t.getAttribute('data-qty')) }).then(renderAll).catch(function () { fetchCart().then(renderAll); });
    } else if (t.hasAttribute('data-subscribe')) {
      t.disabled = true; setPlans(true, null, t).catch(function () { fetchCart().then(renderAll); });
    } else if (t.hasAttribute('data-unsubscribe')) {
      t.disabled = true; setPlans(false, [t.getAttribute('data-unsubscribe')]).catch(function () { fetchCart().then(renderAll); });
    } else if (t.hasAttribute('data-filter')) {
      applyFilter(t);
      // Snap back to the first products so a shorter list never leaves you staring at the footer.
      var grid = $('.collection'), bar = $('.filters');
      if (grid) {
        var y = grid.getBoundingClientRect().top + window.pageYOffset - (bar ? bar.offsetHeight : 0);
        if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'instant' });
      }
    } else if (t.hasAttribute('data-thumb')) {
      var main = $('.js-main-img');
      if (main) { main.removeAttribute('srcset'); }
      if (main) { main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || ''; }
      $$('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    } else if (t.hasAttribute('data-menu-toggle')) {
      var m = $('#MobileMenu'); if (!m) return;
      m.hidden = !m.hidden; t.setAttribute('aria-expanded', String(!m.hidden));
    } else if (t.hasAttribute('data-qty-step')) {
      var input = t.parentNode.querySelector('input');
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(t.getAttribute('data-qty-step')));
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); hideToast(); } });
  // Capture phase again: the old subscription app also listens for product form submits.
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-product-form]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      var fd = new FormData(f);
      fd.delete('selling_plan'); // ignore anything an old subscription widget slipped into the form
      addItems(fd, f.getAttribute('data-title'), false, $('[type=submit]', f));
    } else if (f.matches('[data-drawer-form]')) {
      // let the browser go to checkout
    }
  }, true);
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-variant-select]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var price = $('[data-product-price]'); if (price && opt) price.textContent = opt.getAttribute('data-price');
    var btn = $('[data-product-form] [type=submit]');
    if (btn && opt) { var ok = opt.getAttribute('data-available') === 'true'; btn.disabled = !ok; btn.textContent = ok ? 'Add to cart' : 'Sold out'; }
  });

  /* ---------- filters ---------- */
  function applyFilter(btn) {
    var tags = (btn.getAttribute('data-filter') || '').toLowerCase().split('|').filter(Boolean);
    $$('[data-filter]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var shown = 0;
    $$('[data-card]').forEach(function (card) {
      var ct = (card.getAttribute('data-tags') || '').split('|');
      var ok = !tags.length || tags.some(function (t) { return ct.indexOf(t) !== -1; });
      card.hidden = !ok; if (ok) shown++;
    });
    $$('[data-extras]').forEach(function (x) { x.hidden = !$$('[data-card]:not([hidden])', x).length; });
    var n = $('[data-shown-count]'); if (n) n.textContent = shown;
    try { history.replaceState(null, '', tags.length ? '?filter=' + encodeURIComponent(btn.getAttribute('data-filter-id')) : location.pathname); } catch (x) {}
  }

  document.addEventListener('DOMContentLoaded', function () {
    var q = new URLSearchParams(location.search).get('filter');
    if (q) { var b = $('[data-filter-id="' + q.replace(/"/g, '') + '"]'); if (b) applyFilter(b); }
    fetchCart().then(renderAll).catch(function () {});
    if (new URLSearchParams(location.search).get('cart') === 'open') openDrawer();
  });
  // Pages restored with the Back button (phones keep them frozen in memory) or tabs left open while the cart
  // changed elsewhere would otherwise show an old bottle count. Re-read the real cart whenever the page comes back.
  function refresh() { if (!dealBusy) fetchCart().then(renderAll).catch(function () {}); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });

  // Small API for sections (bundle builder): add several lines, then show the cart.
  window.DGCart = {
    add: function (items) {
      return post(DG.routes.add, { items: items }).then(fetchCart).then(function (c) { renderAll(c); openDrawer(); });
    },
    tiers: tiers,
    money: money
  };
})();
